import React from 'react';
import Pages from './Pages';
import {styled} from '@volkswagen-onehub/components-core';

const AppContainer = styled.div``;

export function App(): JSX.Element {
  return (
    <AppContainer>
      <Pages />
    </AppContainer>
  );
}
